<template>
  <section>
    <ContactHeader />
    <ContactIndex />
  </section>
</template>

<script>
import * as partials from './partials'

export default {
  name: 'Contact',
  components: { ...partials },
  provide() {
    return {
      wp: this.$wp.pages.contact || {}
    }
  },
  mounted() {
    console.log('contact', this.$wp.pages.contact)
  }
}
</script>
